import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  marketCenters: {
    data: null,
    loading: false,
    error: null,
  },
  states: {
    data: null,
    loading: false,
    error: null,
  },
  markets: {
    data: null,
    loading: false,
    error: null,
  },
};

export const getMarketCenters = createAsyncThunk("map/get-market-centers", async (_, { rejectWithValue }) => {
  return fetch("/market-centers.json")
    .then((marketsResponse) => {
      return marketsResponse.json();
    })
    .catch((err) => {
      console.error("Error fetching market centers", err);
      return rejectWithValue(err);
    });
});
export const getUsaStates = createAsyncThunk("map/get-states", async (_, { rejectWithValue }) => {
  return fetch("/usa_continental.json")
    .then((statesResponse) => {
      return statesResponse.json();
    })
    .catch((err) => {
      console.error("Error fetching states", err);
      return rejectWithValue(err);
    });
});
export const getMarkets = createAsyncThunk("map/get-markets", async (_, { rejectWithValue }) => {
  return fetch("/markets-v4.json")
    .then((marketsResponse) => {
      return marketsResponse.json();
    })
    .catch((err) => {
      console.error("Error fetching markets", err);
      return rejectWithValue(err);
    });
});

const mapDataSlice = createSlice({
  name: "mapData",
  initialState,
  reducers: {
    clearMapData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMarketCenters.pending, (state) => {
        state.marketCenters = {
          data: null,
          loading: true,
          error: null,
        };
      })
      .addCase(getMarketCenters.fulfilled, (state, action) => {
        state.marketCenters = {
          data: action.payload,
          loading: false,
          error: null,
        };
      })
      .addCase(getMarketCenters.rejected, (state) => {
        state.marketCenters = {
          data: null,
          loading: false,
          error: "Error fetching market centers",
        };
      })
      .addCase(getUsaStates.pending, (state) => {
        state.states = {
          data: null,
          loading: true,
          error: null,
        };
      })
      .addCase(getUsaStates.fulfilled, (state, action) => {
        state.states = {
          data: action.payload,
          loading: false,
          error: null,
        };
      })
      .addCase(getUsaStates.rejected, (state) => {
        state.states = {
          data: null,
          loading: false,
          error: "Error fetching market centers",
        };
      })
      .addCase(getMarkets.pending, (state) => {
        state.markets = {
          data: null,
          loading: true,
          error: null,
        };
      })
      .addCase(getMarkets.fulfilled, (state, action) => {
        state.markets = {
          data: action.payload,
          loading: false,
          error: null,
        };
      })
      .addCase(getMarkets.rejected, (state) => {
        state.markets = {
          data: null,
          loading: false,
          error: "Error fetching market centers",
        };
      });
  },
});

export const { clearMapData } = mapDataSlice.actions;
export default mapDataSlice.reducer;
